(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("OpenHPS", [], factory);
	else if(typeof exports === 'object')
		exports["OpenHPS"] = factory();
	else
		root["OpenHPS"] = root["OpenHPS"] || {}, root["OpenHPS"]["core"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 